// import httpClient, {httpObjQueryString} from "../config/httpClient";
import {checkSubDomain, setDataParams, SetGateWay} from "./gateway";
import httpClient, {httpObjQueryString} from "../config/httpClient";
import axios from "axios";

const {httpGateWay} = SetGateWay()

export const loginUserApi = (username, password) => {
    return httpGateWay.post(`/user/login`, {
        username: username, password: password, prefix: checkSubDomain()
    })
}

export const fetchUsersApi = (filter) => {
    return httpGateWay.get(`/user/lists?${httpObjQueryString(filter)}`)
}

export const getUserApi = (id) => {
    return httpGateWay.get(`/user/${id}`)
}

export const newUserApi = (data) => {
    return httpGateWay.post(`/user`, setDataParams(data))
}

export const updateUserApi = (id, data) => {
    return httpGateWay.put(`/user/${id}`, setDataParams(data))
}

export const deleteUserApi = (id) => {
    return httpGateWay.delete(`/user/${id}`)
}

export const updateProfileApi = (data) => {
    return httpGateWay.put(`/user/me`, setDataParams(data))
}

export const getProfileApi = () => {
    return httpGateWay.get(`/user/me`)
}


export const checkDomainConfigApi = (domain) => {
    let endpoint = ``
    if (process.env.REACT_APP_ENV !== `local`) {
        endpoint = `/v1`
    }
    return axios.post(`${process.env.REACT_APP_API_BASE}${endpoint}/domain/auth`, {domain: domain})
}
